import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageConfigService } from '../../../../../services/language-config/language-config.service';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';

@Component({
  selector: 'lib-dynamic-page-dc-button',
  standalone: false,
  templateUrl: './dynamic-page-dc-button.component.html',
  styleUrl: './dynamic-page-dc-button.component.scss'
})
export class DynamicPageDcButtonComponent extends DynamicPageDcBaseComponent {
  protected languageConfigService = inject(LanguageConfigService);
  protected translateService = inject(TranslateService);

  translate = false;
  translateLangs = this.languageConfigService.getLanguages().filter(l => l.enabled).map(l => l.short);
  currentLang = this.translateService.currentLang;

  fields = {
    buttonText: 'Button',
    buttonAlign: 'center',
    buttonColor: '#ffffff',
    buttonFontSize: 16,
    buttonBorderRadiusTop: 0,
    buttonBorderRadiusRight: 0,
    buttonBorderRadiusLeft: 0,
    buttonBorderRadiusBottom: 0,
    buttonMarginTop: 0,
    buttonMarginRight: 0,
    buttonMarginBottom: 0,
    buttonMarginLeft: 0,
    buttonPaddingTop: 5,
    buttonPaddingRight: 15,
    buttonPaddingBottom: 5,
    buttonPaddingLeft: 15,
    buttonBackground: '#000000',
    buttonUseFillWidth: false,
    buttonWidth: null,
    buttonTextAlign: 'center',
    buttonLink: '',
  };

  changeTranslate() {
    this.translate = this.element.fields.translate;
    if (this.translate) {
      let currentValue = this.element.fields['buttonText'];

      if (typeof currentValue === 'string' || !currentValue) {
        currentValue = {
          value: currentValue || '',
          i18n: {}
        };
      }

      this.translateLangs.forEach((lang: string) => {
        if (!currentValue.i18n[lang]) {
          currentValue.i18n[lang] = currentValue.value;
        }
      });

      this.element.fields['buttonText'] = currentValue;
    } else {
      const currentValue = this.element.fields['buttonText'];

      if (currentValue && typeof currentValue === 'object' && 'value' in currentValue) {
        this.element.fields['buttonText'] = {
          ...currentValue,
          value: currentValue.value
        };
      }
    }
  }
}
